// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__32sOS","list":"BalanceDue_list__2igQN","listRow":"BalanceDue_listRow__1RQc0","total":"BalanceDue_total__Os2lh"};